module.exports = __webpack_public_path__ + "img/2020.9893482c.svg";